export enum CommercePropertyValueEnum {
    string = 'StringValue',
    decimal = 'DecimalValue',
    boolean = 'BooleanValue'
}
